import React from "react";
import MuiCircularProgress from "@mui/material/CircularProgress";
import MuiButton from "@mui/material/Button";
import MuiSearchIcon from "@mui/icons-material/Search";
import MuiTextField from "@mui/material/TextField";
import MuiFolderOpenIcon from "@mui/icons-material/FolderOpen";
import MuiAutocomplete from "@mui/material/Autocomplete";

// Source
import * as HelperSrc from "../HelperSrc";
import * as ModelHelperSrc from "../model/HelperSrc";
import ControllerLogList from "../controller/LogList";
import ControllerLocalization from "../controller/Localization";
import ViewLoader from "./Loader";
import ViewPagination from "./Pagination";
import ViewDialog from "../view/Dialog";

let isRendered = false;

const viewPageLogList: React.FC = () => {
    // Variable
    const controllerLogList = new ControllerLogList(isRendered);
    const controllerLocalization = new ControllerLocalization(isRendered);

    // Method
    controllerLogList.initializeHook();
    controllerLocalization.initializeHook();

    // Render
    isRendered = true;

    const logListAutocompleteSlotProps = HelperSrc.createAutocompleteSlotProps("view_list_popper", [0, 0]);

    if (
        controllerLocalization.getStorageMain &&
        controllerLogList.getSelectOption &&
        controllerLogList.getPagination &&
        controllerLogList.getFilter &&
        controllerLogList.getDataMainList
    ) {
        return (
            <div className="view_log_list" data-at_id="view_log_list">
                <div>
                    <table>
                        {(() => {
                            const html: JSX.Element[] = [];

                            html.push(
                                <>
                                    <colgroup>
                                        <col className="cell id" />
                                        <col className="cell level" />
                                        <col className="cell source" />
                                        <col className="cell app_name" />
                                        <col className="cell update_by" />
                                        <col className="cell update_date" />
                                    </colgroup>
                                    <thead className="filter">
                                        <tr className="row filter_action">
                                            <td>
                                                <MuiButton
                                                    className="button_primary container_button"
                                                    data-at_id="button_apply"
                                                    disabled={controllerLogList.getApiLoadingList.selectOption}
                                                    onClick={() => {
                                                        controllerLogList.clickFilterApply();
                                                    }}
                                                >
                                                    {(() => {
                                                        const html: JSX.Element[] = [];

                                                        if (controllerLogList.getApiLoadingList.selectOption) {
                                                            html.push(<MuiCircularProgress className="icon_progress" />);
                                                        } else {
                                                            html.push(
                                                                <span className="button_label">
                                                                    {controllerLocalization.getStorageMain.apply} <MuiSearchIcon />
                                                                </span>
                                                            );
                                                        }

                                                        return html;
                                                    })()}
                                                </MuiButton>
                                            </td>
                                        </tr>
                                        <tr className="row not_hover">
                                            <th className="cell field_container">{controllerLocalization.getStorageMain.id}</th>
                                            <th className="cell field_container">
                                                <MuiAutocomplete
                                                    slotProps={logListAutocompleteSlotProps}
                                                    blurOnSelect
                                                    options={(() => {
                                                        const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];

                                                        for (const optionData of Object.values(controllerLogList.getSelectOption.level)) {
                                                            const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                            optionList.push(optionDataTyped);
                                                        }

                                                        return optionList;
                                                    })()}
                                                    getOptionLabel={(option) => option.display_name}
                                                    renderOption={(props, option) => {
                                                        if (controllerLocalization.getStorageMain) {
                                                            return (
                                                                <li {...props}>
                                                                    {option.display_name || controllerLocalization.getStorageMain.select}
                                                                </li>
                                                            );
                                                        }
                                                    }}
                                                    isOptionEqualToValue={(opt, val) => String(opt.value) === String(val.value)}
                                                    renderInput={(params) => (
                                                        <MuiTextField
                                                            {...params}
                                                            variant="outlined"
                                                            className="field_value"
                                                            name="level"
                                                            label={
                                                                controllerLocalization.getStorageMain
                                                                    ? controllerLocalization.getStorageMain.log_level
                                                                    : ""
                                                            }
                                                        />
                                                    )}
                                                />
                                            </th>
                                            <th className="cell field_container">
                                                <MuiAutocomplete
                                                    slotProps={logListAutocompleteSlotProps}
                                                    blurOnSelect
                                                    options={(() => {
                                                        const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];

                                                        for (const optionData of Object.values(controllerLogList.getSelectOption.source)) {
                                                            const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                            optionList.push(optionDataTyped);
                                                        }

                                                        return optionList;
                                                    })()}
                                                    getOptionLabel={(option) => option.display_name}
                                                    renderOption={(props, option) => {
                                                        if (controllerLocalization.getStorageMain) {
                                                            return (
                                                                <li {...props}>
                                                                    {option.display_name || controllerLocalization.getStorageMain.select}
                                                                </li>
                                                            );
                                                        }
                                                    }}
                                                    isOptionEqualToValue={(opt, val) => String(opt.value) === String(val.value)}
                                                    renderInput={(params) => (
                                                        <MuiTextField
                                                            {...params}
                                                            variant="outlined"
                                                            className="field_value"
                                                            name="source"
                                                            label={
                                                                controllerLocalization.getStorageMain
                                                                    ? controllerLocalization.getStorageMain.log_source
                                                                    : ""
                                                            }
                                                        />
                                                    )}
                                                />
                                            </th>
                                            <th className="cell field_container">
                                                <MuiAutocomplete
                                                    slotProps={logListAutocompleteSlotProps}
                                                    blurOnSelect
                                                    options={(() => {
                                                        const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];

                                                        for (const optionData of Object.values(controllerLogList.getSelectOption.app_name)) {
                                                            const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                            optionList.push(optionDataTyped);
                                                        }

                                                        return optionList;
                                                    })()}
                                                    getOptionLabel={(option) => option.display_name}
                                                    renderOption={(props, option) => {
                                                        if (controllerLocalization.getStorageMain) {
                                                            return (
                                                                <li {...props}>
                                                                    {option.display_name || controllerLocalization.getStorageMain.select}
                                                                </li>
                                                            );
                                                        }
                                                    }}
                                                    isOptionEqualToValue={(opt, val) => String(opt.value) === String(val.value)}
                                                    renderInput={(params) => (
                                                        <MuiTextField
                                                            {...params}
                                                            variant="outlined"
                                                            className="field_value"
                                                            name="app_name"
                                                            label={
                                                                controllerLocalization.getStorageMain
                                                                    ? controllerLocalization.getStorageMain.log_application
                                                                    : ""
                                                            }
                                                        />
                                                    )}
                                                />
                                            </th>
                                            <th data-at_id="th_created_by" className="cell field_container">
                                                <MuiAutocomplete
                                                    slotProps={logListAutocompleteSlotProps}
                                                    blurOnSelect
                                                    options={(() => {
                                                        const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];

                                                        for (const optionData of Object.values(controllerLogList.getSelectOption.created_by)) {
                                                            const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                            optionList.push(optionDataTyped);
                                                        }

                                                        return optionList;
                                                    })()}
                                                    getOptionLabel={(option) => option.display_name}
                                                    renderOption={(props, option) => {
                                                        if (controllerLocalization.getStorageMain) {
                                                            return (
                                                                <li
                                                                    {...props}
                                                                    data-at_id={`select_created_by_${option.value ? option.value : "select"}`}
                                                                >
                                                                    {option.display_name || controllerLocalization.getStorageMain.select}
                                                                </li>
                                                            );
                                                        }
                                                    }}
                                                    isOptionEqualToValue={(opt, val) => String(opt.value) === String(val.value)}
                                                    renderInput={(params) => (
                                                        <MuiTextField
                                                            {...params}
                                                            variant="outlined"
                                                            className="field_value"
                                                            name="created_by"
                                                            data-at_id="input_created_by"
                                                            label={
                                                                controllerLocalization.getStorageMain
                                                                    ? controllerLocalization.getStorageMain.created_by
                                                                    : ""
                                                            }
                                                        />
                                                    )}
                                                />
                                            </th>
                                            <th className="cell field_container">{controllerLocalization.getStorageMain.created_date}</th>
                                        </tr>
                                    </thead>
                                </>
                            );

                            return html;
                        })()}
                        <tbody className="log_list_table" data-at_id="tbody_log_list">
                            {(() => {
                                const html: JSX.Element[] = [];

                                if (controllerLogList.getApiLoadingList.dataList) {
                                    html.push(
                                        <tr className="row_empty">
                                            <td>
                                                <MuiCircularProgress className="icon_progress" />
                                            </td>
                                        </tr>
                                    );
                                } else {
                                    if (Object.entries(controllerLogList.getDataMainList).length === 0) {
                                        html.push(
                                            <tr className="empty_state">
                                                <td colSpan={100}>
                                                    <MuiFolderOpenIcon className="icon" />
                                                    <p>{controllerLocalization.getStorageMain.no_result}</p>
                                                </td>
                                            </tr>
                                        );
                                    } else {
                                        for (const [key, data] of Object.entries(controllerLogList.getDataMainList)) {
                                            const alternateRow = Number(key) % 2 === 1 ? "even" : "";

                                            html.push(
                                                <tr
                                                    className={`row ${alternateRow}`}
                                                    data-at_id={`tr_list_data_${data.id}`}
                                                    onClick={() => {
                                                        controllerLogList.clickItem(data);
                                                    }}
                                                >
                                                    <td className="cell">{data.id}</td>
                                                    <td className="cell">{data.level}</td>
                                                    <td className="cell">{data.source}</td>
                                                    <td className="cell">{data.app_name}</td>
                                                    <td className="cell" data-at_id="log_list_created_by">
                                                        {data.created_by}
                                                    </td>
                                                    <td className="cell">
                                                        {data.created_date ? HelperSrc.localeFormat(new Date(data.created_date)) : ""}
                                                    </td>
                                                </tr>
                                            );
                                        }
                                    }
                                }

                                return html;
                            })()}
                        </tbody>
                    </table>
                    <ViewPagination response={controllerLogList.getPagination} api={controllerLogList.apiDataList} />
                    {(() => {
                        const html: JSX.Element[] = [];

                        if (controllerLogList.getDataMain) {
                            html.push(
                                <ViewDialog
                                    className="log_dialog"
                                    isOpen={controllerLogList.getIsDialogOpen}
                                    isApiLoading={false}
                                    labelConfirm={controllerLocalization.getStorageMain.close}
                                    onClickConfirm={controllerLogList.clickDialogClose}
                                    labelCancel={""}
                                    onClickCancel={() => {
                                        //...
                                    }}
                                    mode={""}
                                    content={
                                        <div>
                                            <div className="title">{controllerLocalization.getStorageMain.log_detail}</div>
                                            <div className="detail">
                                                <div className="row">
                                                    <p>
                                                        <b>{controllerLocalization.getStorageMain.log_level}: </b>
                                                        {controllerLogList.getDataMain.level || ""}
                                                    </p>
                                                    <p>
                                                        <b>{controllerLocalization.getStorageMain.created_by}: </b>
                                                        {controllerLogList.getDataMain.created_by || ""}
                                                    </p>
                                                </div>
                                                <div className="row">
                                                    <p>
                                                        <b>{controllerLocalization.getStorageMain.log_source}: </b>
                                                        {controllerLogList.getDataMain.source || ""}
                                                    </p>
                                                    <p>
                                                        <b>{controllerLocalization.getStorageMain.created_date}: </b>
                                                        {controllerLogList.getDataMain.created_date
                                                            ? HelperSrc.localeFormat(new Date(controllerLogList.getDataMain.created_date))
                                                            : ""}
                                                    </p>
                                                </div>
                                                <div className="row">
                                                    <p>
                                                        <b>{controllerLocalization.getStorageMain.log_application}: </b>
                                                        {controllerLogList.getDataMain.app_name || ""}
                                                    </p>
                                                </div>
                                                <div className="row">
                                                    <p>
                                                        <b>{controllerLocalization.getStorageMain.function_name}: </b>
                                                        {controllerLogList.getDataMain.function_name || ""}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="title">{controllerLocalization.getStorageMain.message}</div>
                                            <textarea
                                                className="message"
                                                defaultValue={controllerLogList.getDataMain.message.replace(/^([^-]*)/gm, "") || ""}
                                            />
                                        </div>
                                    }
                                />
                            );
                        }

                        return html;
                    })()}
                </div>
            </div>
        );
    } else {
        return <ViewLoader />;
    }
};

export default viewPageLogList;
